import React, { useState, useEffect } from "react";
import { Link, useHistory } from "react-router-dom";
import Sidebar from "../../../partials/aside/Sidebar";
import validateFormAddSitePublishers from "../../../../validtions/forms/site-publishers/add-site-publishers";
import httpService from "../../../../services/httpServices/httpServices";
import helperSpinner from "../../../../helpers/spinner";
import helperNumbers from "../../../../helpers/numbers";

function AddSitePublisher() {
  const [tagCategories, setTagCategories] = useState();
  const [maxPriority, setMaxPriority] = useState();
  const [message, setMessage] = useState();
  const history = useHistory();
  let messageTag;

  if (message) {
    messageTag = (
      <div className={`${message.type_class}`}>
        <i className={`${message.class_icon} pl-2`}></i>
        <span>{message.text}</span>
      </div>
    );
  }

  useEffect(() => {
    getCategoriesSitePublisher();
  }, []);

  useEffect(() => {
    if (!tagCategories) {
      return;
    }
    getMaxPrioritySitePublishers();
  }, [tagCategories]);

  const sendRequestGetCategoriesSitePublisher = async () => {
    const headersRequest = getHeaderForRequest();
    let categoriesSitePublishers;
    try {
      categoriesSitePublishers = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/manage/category-site-publishers",
        headersRequest
      );
    } catch (error) {
      return false;
    }

    return categoriesSitePublishers.data.data;
  };

  const getHeaderForRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const generateTagCategories = (categoriesSitePublisher) => {
    return categoriesSitePublisher.map((categorySitePublisher, index) => {
      return (
        <div key={index} className="col-12 col-sm-6 col-md-3  ">
          <span className="w-100 justify-content-between d-inline-flex align-items-center py-2">
            <span className="small font-weight-bold text-nowrap">
              {categorySitePublisher.cas_name}
            </span>
            <span>
              <label className="adl-switch">
                <input
                  type="checkbox"
                  className="categories-site-publisher"
                  defaultValue={categorySitePublisher.cas_id}
                />
                <span className="adl-slider round"></span>
              </label>
            </span>
          </span>
        </div>
      );
    });
  };

  const getCategoriesSitePublisher = async () => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const categoriesSitePublisher =
      await sendRequestGetCategoriesSitePublisher();
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    setTagCategories(generateTagCategories(categoriesSitePublisher));
  };

  const getMaxPrioritySitePublishers = async () => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const maxPriority = await sendRequestGetMaxPrioritySitePublishers();
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    setMaxPriority(maxPriority);
  };

  const sendRequestGetMaxPrioritySitePublishers = async () => {
    const headersRequest = getHeaderForRequest();
    let result;
    try {
      result = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API + "/v1/site-publishers/max-priority",
        headersRequest
      );
    } catch (error) {
      setMessage({
        type_class: "alert alert-danger",
        text: error.response.data.message,
        class_icon: "fa fa-exclamation-triangle",
      });
      return false;
    }
    return result.data.data;
  };

  const sendForm = async (e) => {
    e.preventDefault();
    const formData = getFormData();

    if (validateFormAddSitePublishers(formData) != true) {
      setMessage({
        type_class: "alert alert-danger",
        text: validateFormAddSitePublishers(formData),
        class_icon: "fa fa-exclamation-triangle",
      });

      return;
    }

    formData.types = formData.type_advertise;
    formData.categories = formData.categories_site_publisher;

    delete formData.type_advertise;
    delete formData.categories_site_publisher;
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const result = await sendRequestAddSitePublisher(formData);
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    if (!result) {
      return;
    }
    history.push("/manage/publishers/all");
  };

  const getFormData = () => {
    const url = document.getElementById("url").value;

    const checkBoxesCategoriesSitePublisher = document.querySelectorAll(
      ".categories-site-publisher:checked"
    );
    let categoriesSitePublisher = [];
    checkBoxesCategoriesSitePublisher.forEach((checkBox) => {
      if (checkBox.defaultValue) {
        categoriesSitePublisher.push(checkBox.defaultValue);
      }
    });

    const checkBoxesTypeAdvertise = document.querySelectorAll(
      ".type-advertise:checked"
    );
    let typeAdvertise = [];
    checkBoxesTypeAdvertise.forEach((checkBox) => {
      typeAdvertise.push(checkBox.defaultValue);
    });

    return {
      url: url,
      categories_site_publisher: categoriesSitePublisher,
      type_advertise: typeAdvertise,
      publisher_id: document.querySelector("#publisher-id").value,
      active: document.querySelector("#active").checked,
      priority: document.querySelector("#priority").value,
    };
  };

  const sendRequestAddSitePublisher = async (formData) => {
    const headersRequest = getHeaderForRequest();

    try {
      await httpService.postRequest(
        process.env.REACT_APP_DOMAIN_API + "/v1/site-publishers",
        formData,
        headersRequest
      );
      return true;
    } catch (error) {
      setMessage({
        type_class: "alert alert-danger",
        text: error.response.data.message,
        class_icon: "fa fa-exclamation-triangle",
      });
      return false;
    }
  };

  return (
    <>
      <Sidebar openItem="manage-category-publisher-menu" />
      <div className="content-wrapper">
        <section className="content-header pt-4  pb-0">
          <div className="container-fluid">
            <div className="row">
              <div className="w-100 text-center">
                <h1 className="px-5 py-1  bg-warning">
                  اضافه کردن سایت نمایش دهنده
                </h1>
              </div>
            </div>
          </div>
        </section>

        <section className="content">
          <div className="card">
            <div className="card-body">
              <div className="text-left pb-2">
                <Link to="/manage/publishers/all" className="btn btn-primary">
                  <span>بازگشت</span>
                  <span className="pr-2">
                    <i className="fas fa-arrow-left"></i>
                  </span>
                </Link>
              </div>
              {messageTag}

              <div className="alert alert-warning">
                <p className="text-justify">
                  <i className="fa fa-info pl-2"></i>
                  توجه داشته باشید :{" "}
                </p>
                <ul className="pr-3">
                  <li>
                    <p className="text-justify">
                      آدرس سایت باید با https و بدون صفحه و آخرین حرف فاقد "/"
                      باشد. مثال https://monirlock.ir
                    </p>
                  </li>
                  <li>
                    <p>
                      در صورتیکه مالک وب سایت شرکت هایلات باشد شماره کاربر نمایش
                      دهنده (مالک وب سایت) برابر با 0 قرار دهید.
                    </p>
                  </li>
                </ul>
              </div>

              <form onSubmit={sendForm}>
                <div className="form-group">
                  <label>آدرس سایت</label>
                  <input
                    type="text"
                    id="url"
                    dir="ltr"
                    className="form-control"
                  />
                </div>
                <div className="form-group">
                  <label>شماره کاربر نمایش دهنده (مالک وب سایت)</label>
                  <input
                    type="number"
                    onWheel={(e) => e.target.blur()}
                    id="publisher-id"
                    className="form-control"
                  />
                </div>
                <div className="py-2">
                  <label className="pl-2">
                    اولویت برای گروه نمایش دهنده خودکار{" "}
                    {maxPriority && (
                      <span>
                        ( بالاترین اولویت سایت =
                        {helperNumbers.toPersianNum(maxPriority)})
                      </span>
                    )}
                  </label>
                  <input
                    type="number"
                    onWheel={(e) => e.target.blur()}
                    id="priority"
                    className="form-control"
                  />
                </div>
                <div className="form-group">
                  <label className="pl-2">فعال بودن سایت</label>
                  <span>
                    <label className="adl-switch">
                      <input name="active" type="checkbox" id="active" />
                      <span className="adl-slider round"></span>
                    </label>
                  </span>
                </div>
                <div>
                  <label>نوع تبلیغ</label>
                  <div className="container-fluid">
                    <div className="row alert alert-secondary">
                      <div className="col-12 col-sm-6 col-md-3 ">
                        <span className="w-100 justify-content-between d-inline-flex align-items-center py-2">
                          <span className="small font-weight-bold text-nowrap">
                            بنری
                          </span>
                          <span>
                            <label className="adl-switch">
                              <input
                                type="checkbox"
                                className="type-advertise"
                                value="1"
                              />
                              <span className="adl-slider round"></span>
                            </label>
                          </span>
                        </span>
                      </div>
                      {/* 
                      <div className="col-12 col-sm-6 col-md-3">
                        <span className="w-100 justify-content-between d-inline-flex align-items-center py-2">
                          <span className="small font-weight-bold text-nowrap">
                            همسان
                          </span>
                          <span>
                            <label className="adl-switch">
                              <input
                                type="checkbox"
                                className="type-advertise"
                                value="2"
                              />
                              <span className="adl-slider round"></span>
                            </label>
                          </span>
                        </span>
                      </div> */}
                    </div>
                  </div>
                </div>

                <div>
                  <label>دسته سایت های نمایش دهنده</label>
                  <div className="container-fluid">
                    <div className="row alert alert-secondary">
                      {tagCategories}
                    </div>
                  </div>
                </div>

                <button type="submit" className="btn btn-primary">
                  اضافه کردن
                </button>
              </form>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default AddSitePublisher;
